import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
const { connect } = require('react-redux');
import { RootCategory, SearchUsage } from 'models';
import {
	setWardrobeItemSelectedCategory,
	getWardrobeItemsSearchResults,
	setWardrobeItemSearchKeyword,
} from 'redux/modules/search/wardrobeitemsearchresults';
import {
	IWardrobeItemSearchResultsAction,
	IProductSearchResultsAction,
	IProductSearchResultsData,
	IWardrobeItemSearchResultsData,
} from 'models/search/productbasesearchresults';
import { IStore } from 'redux/IStore';
import { getWishlist } from 'redux/modules/user/wishlist';
import { IWishlistAction, IWishlistData } from 'models/user/wishlist';
import { IUserPreferences } from 'models/user/userpreferences';
import {
	setProductSelectedCategory,
	getProductSearchResults,
	setProductSearchKeyword,
} from 'redux/modules/search/productsearchresults';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { WardrobeItemSearchResults } from '../../Search/WardrobeItemSearchResults';
import { WishlistSearchResults } from '../../Search/WishlistSearchResults';
import { ProductSearchResults } from '../../Search/ProductSearchResults';
import { ItemCardList, SearchInput } from 'components';
import { IItemCardList } from 'models/itemcard';
import { INodeData, ISelectorItem } from 'models/common';
require('./style.css');

interface IProps {
	userId: string;
	items: ISelectorItem[];
	userPreferences?: IUserPreferences;
	wardrobeItemsSearchResultsData?: IWardrobeItemSearchResultsData;
	productsSearchResultsData?: IProductSearchResultsData;
	wishlist?: IWishlistData;
	hideWishlistTab?: boolean;
	hideProductsTab?: boolean;
	hideWardrobeItemsTab?: boolean;
	selectedTab: string;
	wardrobeItemsSearchUsage: SearchUsage;
	productsSeachUsage: SearchUsage;

	/* functions props */
	onSelectItemObject: (item: any) => void;
	onRemoveItem: (index: number) => void;
	t?: (key: string) => string;
	setWardrobeItemSelectedCategory?: (selectedCategoryId: number) => IWardrobeItemSearchResultsAction;
	getWardrobeItemsSearchResults?: (
		isFirstLoad: boolean,
		isRefinement: boolean,
		usage: SearchUsage,
	) => IWardrobeItemSearchResultsAction;
	getWishlist?: (userId: string, isFirstLoad: boolean) => IWishlistAction;
	setProductSelectedCategory?: (selectedCategoryId: number) => IProductSearchResultsAction;
	getProductSearchResults?: (
		isFirstLoad: boolean,
		isRefinement: boolean,
		usage: SearchUsage,
	) => IProductSearchResultsData;
	setWardrobeItemSearchKeyword?: (keyword: string) => IWardrobeItemSearchResultsAction;
	setProductSearchKeyword?: (keyword: string) => IProductSearchResultsAction;
	dispatch?: any;
}

interface IState {
	selectedTab: string;
	tabsNamespace: string;
	categoryId: number;
}

@connect(
	(state: IStore) => {
		return {
			userPreferences: state.userPreferences,
			wardrobeItemsSearchResultsData: state.wardrobeItemSearchResults,
			productsSearchResultsData: state.productSearchResults,
			wishlist: state.wishlist,
		};
	},
	(dispatch) => ({
		setWardrobeItemSelectedCategory: (selectedCategoryId: number) =>
			dispatch(setWardrobeItemSelectedCategory(selectedCategoryId)),
		getWardrobeItemsSearchResults: (isFirstLoad: boolean, isRefinement: boolean, usage: SearchUsage) =>
			dispatch(getWardrobeItemsSearchResults(isFirstLoad, isRefinement, usage)),
		getWishlist: (userId: string, isFirstLoad: boolean) => dispatch(getWishlist(userId, isFirstLoad)),
		setProductSelectedCategory: (selectedCategoryId: number) =>
			dispatch(setProductSelectedCategory(selectedCategoryId)),
		getProductSearchResults: (isFirstLoad: boolean, isRefinement: boolean, usage: SearchUsage) =>
			dispatch(getProductSearchResults(isFirstLoad, isRefinement, usage)),
		setProductSearchKeyword: (keyword: string) => dispatch(setProductSearchKeyword(keyword)),
		setWardrobeItemSearchKeyword: (keyword: string) => dispatch(setWardrobeItemSearchKeyword(keyword)),
		dispatch,
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ItemsSelector extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			selectedTab: this.props.selectedTab,
			tabsNamespace: 'itemsselectortabs',
			categoryId: RootCategory.Women,
		};

		this.changeTabAndGetRequiredData = this.changeTabAndGetRequiredData.bind(this);
		this.selectItemObject = this.selectItemObject.bind(this);
		this.removeItem = this.removeItem.bind(this);
		this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
		this.handleSearchEnterPress = this.handleSearchEnterPress.bind(this);
	}

	public componentDidMount() {
		this.changeTabAndGetRequiredData(this.state.selectedTab);
	}

	private selectItemObject(item: any) {
		this.props.onSelectItemObject(item);
	}

	private removeItem(index: number) {
		this.props.onRemoveItem(index);
	}

	private changeTabAndGetRequiredData(selectedTab: string) {
		this.setState({ selectedTab });

		switch (selectedTab) {
			case c.ITEMS_SELECTOR_TAB_WARDROBE:
				this.props.setWardrobeItemSelectedCategory(this.state.categoryId);
				this.props.getWardrobeItemsSearchResults(true, false, this.props.wardrobeItemsSearchUsage);
				break;

			case c.ITEMS_SELECTOR_TAB_WISHLIST:
				this.props.getWishlist(this.props.userId, true);
				break;

			case c.ITEMS_SELECTOR_TAB_PRODUCT:
				this.props.setProductSelectedCategory(this.state.categoryId);
				this.props.getProductSearchResults(true, false, this.props.productsSeachUsage);
				break;

			default:
				break;
		}
	}

	private handleSearchValueChange(e: any) {
		const value: string = e.target.value;
		if (this.state.selectedTab === c.ITEMS_SELECTOR_TAB_WARDROBE) {
			this.props.setWardrobeItemSearchKeyword(value.length > 0 ? value : '');
		} else if (this.state.selectedTab === c.ITEMS_SELECTOR_TAB_PRODUCT) {
			this.props.setProductSearchKeyword(value.length > 0 ? value : '');
		}

		this.forceUpdate();
	}

	private handleSearchEnterPress(event: any) {
		if (event.key === 'Enter') {
			if (this.state.selectedTab === c.ITEMS_SELECTOR_TAB_WARDROBE) {
				if (
					this.props.wardrobeItemsSearchResultsData.keyword.length === 0 ||
					this.props.wardrobeItemsSearchResultsData.keyword.length > 2
				) {
					this.props.getWardrobeItemsSearchResults(true, false, this.props.wardrobeItemsSearchUsage);
				}
			} else if (this.state.selectedTab === c.ITEMS_SELECTOR_TAB_PRODUCT) {
				if (
					this.props.productsSearchResultsData.keyword.length === 0 ||
					this.props.productsSearchResultsData.keyword.length > 2
				) {
					this.props.getProductSearchResults(true, false, this.props.productsSeachUsage);
				}
			}
		}
	}

	private renderSearchInput() {
		if (this.state.selectedTab === c.ITEMS_SELECTOR_TAB_WISHLIST) {
			return null;
		}

		const searchInputProps = {
			keyword:
				this.state.selectedTab === c.ITEMS_SELECTOR_TAB_WARDROBE
					? this.props.wardrobeItemsSearchResultsData.keyword
					: this.props.productsSearchResultsData.keyword,
			onSearchEnterPress: this.handleSearchEnterPress,
			onSearchValueChange: this.handleSearchValueChange,
		};

		return <SearchInput {...searchInputProps} />;
	}

	public render() {
		const { t, items } = this.props;
		const { tabsNamespace, selectedTab } = this.state;

		const listItems = items.map((x, i) => {
			return {
				...x,
				key: `${(JSON.parse(x.entityId) as INodeData).id}_${i}`,
			};
		});

		const listProps: IItemCardList = {
			items: listItems,
			itemType: c.NODE_TYPE_SELECTOR_ITEM_CARD,
			removeItem: this.removeItem,
			selectItemObject: this.selectItemObject,
		};

		return (
			<div className="itemSelectorComponent">
				<Tabs
					name={tabsNamespace}
					tabComponent="div"
					className="profileTabs"
					handleSelect={(selectedTab) => {
						this.changeTabAndGetRequiredData(selectedTab);
					}}
					selectedTab={selectedTab}
				>
					<div className="tabLinks">
						<div className="tabLinksPositionMiddle">
							<div className="container">
								<div className="col-md-11 wrapperBottomHeader">
									<div className="row">
										<div className="col-md-7 leftBlock">
											{!this.props.hideWardrobeItemsTab ? (
												<TabLink key="wardrobetablink" className="tabLink" to={c.ITEMS_SELECTOR_TAB_WARDROBE}>
													{t('Outfit_CreateOutfit_SelectItems_Tab_Wardrobe')}
												</TabLink>
											) : null}
											{!this.props.hideWishlistTab ? (
												<TabLink key="wishlistitemstablink" className="tabLink" to={c.ITEMS_SELECTOR_TAB_WISHLIST}>
													{t('Outfit_CreateOutfit_SelectItems_Tab_Wishlist')}
												</TabLink>
											) : null}
											{!this.props.hideProductsTab ? (
												<TabLink key="producttablink" className="tabLink" to={c.ITEMS_SELECTOR_TAB_PRODUCT}>
													{t('Outfit_CreateOutfit_SelectItems_Tab_Products')}
												</TabLink>
											) : null}
										</div>
										<div className="col-md-5 rightBlock">{this.renderSearchInput()}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="itemsWrapper">
						<h2>{t('BSPortal_Common_SelectedItems')}</h2>
						<div className="row">
							<ItemCardList {...listProps} />
						</div>
					</div>
					<div className="row">
						<div className="col-sm-10">
							{!this.props.hideWardrobeItemsTab ? (
								<TabContent key="wardrobeitemstabcontent" for={c.ITEMS_SELECTOR_TAB_WARDROBE}>
									<WardrobeItemSearchResults
										goToCard={null}
										disableCardActions={true}
										selectItem={(item) => this.selectItemObject(item)}
										filterGender={true}
										usage={this.props.wardrobeItemsSearchUsage}
									/>
								</TabContent>
							) : null}
							{!this.props.hideWishlistTab ? (
								<TabContent key="wishlisttabcontent" for={c.ITEMS_SELECTOR_TAB_WISHLIST}>
									<WishlistSearchResults
										userId={this.props.userId}
										goToCard={null}
										selectItem={(item) => this.selectItemObject(item)}
									/>
								</TabContent>
							) : null}
							{!this.props.hideProductsTab ? (
								<TabContent key="producttabcontent" for={c.ITEMS_SELECTOR_TAB_PRODUCT}>
									<ProductSearchResults
										goToCard={null}
										disableCardActions={true}
										selectItem={(item) => this.selectItemObject(item)}
										filterGender={true}
										usage={this.props.productsSeachUsage}
									/>
								</TabContent>
							) : null}
						</div>
						<div className="col-sm-1" />
					</div>
				</Tabs>
			</div>
		);
	}
}

export { ItemsSelector };
